import { heroStats } from "@/mocks/homeData";

export default function Hero() {
  return (
    <section
      id="home"
      className="relative flex min-h-[92vh] w-full items-center overflow-hidden"
    >
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20artistic%20portrait%20photography%20magazine%20background%20with%20soft%20golden%20studio%20lighting%2C%20flowing%20translucent%20silk%20fabric%20and%20delicate%20rose%20petals%2C%20dreamy%20warm%20bokeh%2C%20luxurious%20feminine%20aesthetic%2C%20cream%20and%20rose%20gold%20tones%2C%20sophisticated%20minimal%20composition%2C%20no%20people%2C%20high%20detail&width=1600&height=900&seq=yv-hero-01&orientation=landscape"
        alt="妖精视频写真集主视觉背景"
        className="absolute inset-0 h-full w-full object-cover object-center animate-slowZoom"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/85" />

      <div className="relative z-10 w-full px-4 pb-16 pt-28 md:px-8 md:pt-32">
        <div className="mx-auto max-w-3xl animate-fadeUp text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs text-background-100 backdrop-blur-sm md:text-sm">
            <i className="ri-sparkling-2-line text-accent-300" />
            每日更新 · 高清写真集与私拍美图珍藏
          </span>

          <h1 className="mt-6 font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl lg:text-6xl">
            妖精视频写真集
            <span className="mt-3 block text-xl font-medium text-accent-300 md:text-3xl lg:text-4xl">
              高清私拍美图 · 女主写真珍藏馆
            </span>
          </h1>

          <p className="mx-auto mt-6 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            这里汇集高清写真集、福利图片与私拍美图，按私拍、时尚、外拍、居家、制服与胶片分类整理，
            展示女主的迷人瞬间与摄影质感。喜欢收藏美图的你，可以在一个页面内按类别浏览、搜索与筛选，
            每天都有新内容。
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#latest"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
            >
              <i className="ri-image-2-line" />
              浏览最新写真
            </a>
            <a
              href="#archive"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20 sm:w-auto"
            >
              <i className="ri-search-line" />
              进入珍藏库
            </a>
          </div>
        </div>

        <div className="mx-auto mt-14 grid max-w-4xl grid-cols-2 gap-3 md:grid-cols-4 md:gap-5">
          {heroStats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-50/15 bg-background-50/10 px-4 py-4 text-center backdrop-blur-sm"
            >
              <div className="font-heading text-xl font-bold text-accent-300 md:text-2xl">
                {stat.value}
              </div>
              <div className="mt-1 text-xs text-background-200 md:text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}